/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, get, isEmpty, isFunction, uniq } from "lodash";
import React, { useEffect, useState } from "react";
// components
import IconButton from "../Button/IconButton";
import Icon from "../Icon";
// utils
import { classnames } from "../../utils/text";
//assets
import CompanyIcon from "../../assets/images/icon/custom-tree/company-icon.svg"
import OpenIcon from "../../assets/images/icon/custom-tree/switch-open-icon.svg"
import CloseIcon from "../../assets/images/icon/custom-tree/switch-close-icon.svg"
import CheckboxIcon from "../../assets/images/icon/custom-tree/check-box-icon.svg"
import CheckboxCheckedIcon from "../../assets/images/icon/custom-tree/check-box-checked-icon.svg"
import emptyUserImage from "../../assets/images/empty-user-img.png";

const TreeItem = (props) => {
  const { selectable, checkable, treeData, handleSelect, handleChecked, selected, setSelected, checkedList, setCheckedList, checkedKeys, isSingle } = props
  const [open, setOpen] = useState(true)

  // 선택 액션
  const handleOnSelected = (e) => {
    if (selectable) {
      const keys = [treeData.key]
      if (selected === treeData) {
        const nodeData = {
          selected: false,
          node: treeData
        }
        setSelected(null)
        if (isFunction(handleSelect)) handleSelect(keys, nodeData)
      } else {
        const nodeData = {
          selected: true,
          node: treeData
        }
        setSelected(treeData)
        if (isFunction(handleSelect)) handleSelect(keys, nodeData)
      }
    }

    if (checkable && treeData.isEmployee) {
      if (!checkedList.includes(treeData)) {
        if (isSingle) return setCheckedList([treeData]);
        setCheckedList((oldVal) => [...oldVal, treeData])
      } else {
        setCheckedList(checkedList.filter(list => list !== treeData))
      }
    }
  }

  // 체크 액션
  const handleOnChecked = (e) => {
    const checked = e.target.checked
    if (checkable) {
      if (checked) {
        if (isSingle) return setCheckedList([treeData])
        setCheckedList((oldVal) => [...oldVal, treeData])
      } else {
        setCheckedList(checkedList.filter(list => list !== treeData))
      }
    }
  }

  useEffect(() => {
    if (checkable && isFunction(handleChecked)) {
      const keys = checkedList.map(li => li.key)
      const event = {
        checkedNodes: checkedList
      }
      handleChecked(keys, event)
    }
  }, [checkedList])


  return (
    <li className="custom-tree-item">
      <div className={classnames("item-wrap", { selected: selected === treeData })}>
        {!isEmpty(treeData.children) && (
          <IconButton
            icon={treeData.key === 'company' ? CompanyIcon : open ? OpenIcon : CloseIcon}
            action={() => setOpen(!open)}
          />
        )}
        {treeData.icon && (
          <Icon src={treeData.icon} alt={treeData.title} />
        )}
        {checkable && treeData.isChecked && (
          <>
            <input
              id={`checkbox-${treeData.key}`}
              type="checkbox"
              className="tree-check-box"
              checked={checkedKeys.includes(treeData.key)}
              onChange={handleOnChecked}
            />
            <label
              htmlFor={`checkbox-${treeData.key}`}
              className="custom-tree-check-box"
            >
              <Icon src={checkedKeys.includes(treeData.key) ? CheckboxCheckedIcon : CheckboxIcon} alt={`checkbox-${treeData.key}`} />
            </label>
          </>
        )}
        {treeData.isEmployee && (
          <>
            <div className="tree-profile-image-wrap">
              <img
                className="tree-profile-img"
                alt={get(treeData, "title")}
                src={get(treeData, "profileImg") || emptyUserImage}
              />
            </div>
          </>
        )}
        <span className="tree-title" onClick={handleOnSelected}>{treeData.title}</span>
      </div>
      {!isEmpty(treeData.children) && (
        <ul className={classnames("children-container", { ishide: !open, selected: selected === treeData })}>
          {treeData.children.map((child, idx) =>
            <TreeItem
              key={idx}
              selectable={selectable}
              checkable={checkable}
              treeData={child}
              selected={selected}
              setSelected={setSelected}
              handleSelect={handleSelect}
              handleChecked={handleChecked}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              checkedKeys={checkedKeys}
              isSingle={isSingle}
            />)}
        </ul>
      )}
    </li>
  )
}

const CustomTree = (props) => {
  const { checkable = false, selectable = true, checkedKeys, treeData, handleSelect, handleChecked, isSingle, reCheck, setReCheck } = props
  const [selected, setSelected] = useState(treeData[0])
  const [checkedList, setCheckedList] = useState([])
  const [isFirst, setIsFirst] = useState(true)
  const checked = []
  useEffect(() => {
    if (!isEmpty(treeData) && !isEmpty(checkedKeys)) {
      if (isFirst) {
        findCheckedList(checked, treeData)
        setCheckedList(uniq(checked))
      }
      setIsFirst(false)
    }
  }, [treeData, checkedKeys])

  useEffect(() => {
    if (!isEmpty(treeData)) {
      if(reCheck) {
        findCheckedList(checked, treeData)
        setCheckedList(uniq(checked))
        setReCheck(false)
      }
    }
  }, [checkedKeys])

  const findCheckedList = (list, searchData) => {
    forEach(checkedKeys, key => {
      forEach(searchData, data => {
        if (isEmpty(data.children)) {
          if (key === data.key && data.isChecked) {
            list.push(data)
          } else return
        } else {
          findCheckedList(list, data.children)
        }
      })
    })
  }

  return (
    <div className="custom-tree-container">
      <ul className="custom-tree-list">
        {treeData.map((_data, idx) => (
          <TreeItem
            key={idx}
            treeData={_data}
            selected={selected}
            setSelected={setSelected}
            handleSelect={handleSelect}
            handleChecked={handleChecked}
            checkable={checkable}
            checkedKeys={checkedKeys}
            selectable={selectable}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
            isSingle={isSingle}
          />
        ))}
      </ul>
    </div>
  )
}

export default CustomTree